/* eslint-disable @next/next/no-img-element */
import {env} from 'next-runtime-env';
import classNames from 'classnames';
import useRequest from '@utils/hooks/useRequestCustom';
import React, {useContext, useEffect, useState} from 'react';
import useCommon from '@utils/hooks/common';
import {EmojiContext} from '@utils/context';
import {sortEmojiOrder} from '@utils/index';
import playerItemApi from '@utils/api/playerItem.api';
import EmojiItemButton from '@components/game-recharge/EmojiItemButton';
import styles from './styles';

const NEXT_PUBLIC_URL = env('NEXT_PUBLIC_URL');

const EmojiList = React.memo(
  (props: {
    playerItemList: Array<{item: {}; itemId: number; numberOfItem: number; playerId: number}>;
    emojiList: Array<{id: number; diamond: number; image: string}>;
  }) => {
    const {classes, user} = useCommon({
      withStyles: styles,
      observers: ['user'],
    });

    const diamondBalance = user.getDiamondWalletBalance();

    const emojiContext = useContext(EmojiContext);

    const {emojiList, playerItemList} = props;

    const onEmojiButtonClicked = async (emojiId: number, emojiImage: any) => {
      emojiContext.toggleStickerDrawerVisibility(false);
      emojiContext.setIsEmojiSendingByContext(true);
      setTimeout(() => {
        emojiContext.setIsEmojiSendingByContext(false);
      }, 5000);
      emojiContext.onClickEmoji({diamondItemId: emojiId, image: emojiImage});
      await emojiContext.shootEmoji(emojiContext.emojiSenderId, emojiContext.emojiReceiverId);
      user?.getPlayerInfo();
    };
    // console.log('--- playerItemList in React.memo EmojiList --- ', playerItemList);

    if (!Array.isArray(emojiList)) return null;
    return (
      <div className={classes.emojiListRow}>
        {emojiList
          // sort free emojis at the end
          ?.sort(sortEmojiOrder)
          .map(emoji => {
            const matchingItem = playerItemList?.find(array1Item => array1Item.itemId === emoji.id);
            const numberOfItems = matchingItem?.numberOfItem ?? 0;

            return (
              <div
                key={`${emoji.id}`}
                className={classNames({
                  [classes.disabledEffect]: diamondBalance < emoji.diamond && numberOfItems === 0,
                })}
              >
                <EmojiItemButton
                  // buttonFunction={() =>
                  //   setTimeout(() => {
                  //     handleClick(emoji.id, emoji.image);
                  //   }, 3000)
                  // }
                  buttonFunction={() => onEmojiButtonClicked(emoji.id, emoji.image)}
                  emojiImage={
                    <img
                      src={`${NEXT_PUBLIC_URL}${emoji.image}`}
                      alt="emoji"
                      height={50}
                      width={50}
                    />
                  }
                  ownedAmount={numberOfItems}
                  diamondNeeded={emoji.diamond}
                />
              </div>
            );
          })}
      </div>
    );
  },
  (prevProps, nextProps) => {
    if (!prevProps?.emojiList || !nextProps?.emojiList) return false;
    if (
      prevProps?.emojiList === nextProps?.emojiList &&
      prevProps?.playerItemList === nextProps?.playerItemList
    )
      return true;
    // if (prevProps?.emojiList === nextProps?.emojiList) return true;
    if (prevProps?.emojiList?.length !== nextProps?.emojiList?.length) return false;

    for (let iii = 0; iii < prevProps?.emojiList.length; iii += 1) {
      if (prevProps?.emojiList[iii] !== nextProps?.emojiList[iii]) {
        return false;
      }
    }
    return false;
  }
);
EmojiList.displayName = 'EmojiList';

const EmojiPanel = React.memo(
  (props: {
    isEmojiPanelVisible: boolean;
    emojiList: Array<{id: number; diamond: number; image: string}>;
    playerItemList: Array<{item: {}; itemId: number; numberOfItem: number; playerId: number}>;
  }): JSX.Element => {
    const {classes, user} = useCommon({
      withStyles: styles,
      observers: ['user'],
    });
    const {isEmojiPanelVisible, emojiList, playerItemList} = props;

    return (
      <section className={classes.emojiPanelContainer}>
        <EmojiList emojiList={emojiList} playerItemList={playerItemList} />
      </section>
    );
  }
);

export default EmojiPanel;

EmojiPanel.displayName = 'EmojiPanel';
